import {globeSvg as Icon__small__globeSvg} from '../Icon__small/Icon__small--globe.js'

export var globe = {
  name: 'globe',
  category: 'icon',
  colorable: true,
  svg: Icon__small__globeSvg,
};
